import i18n from '@/plugins/i18n'

function isDayLightOffset(date) {
  var jan = new Date(date.getFullYear(), 0, 1)
  var jul = new Date(date.getFullYear(), 6, 1)
  var stdTimezoneOffset = Math.max(
    jan.getTimezoneOffset(),
    jul.getTimezoneOffset()
  )

  return date.getTimezoneOffset() < stdTimezoneOffset
}

/*
Helper za formatiranje datuma labela u fieldovima
Podesavanje je u src\plugins\i18n.js
Konfigurisani su sledeci formati :
long:15.5.2020. 00:00:00
medium:15.5.2020. 00:00
short:15.5.2020.

uct- parametar koji definise da li treba uct vreme transormisati u lokalno
*/

export default (
  date,
  type = 'long',
  uct = false,
  returnUnFormmatedLocalTime = false,
  enforcedDateFormatLang = null
) => {
  let localeToUse = i18n.fallBackLocale
  if (enforcedDateFormatLang != null) {
    localeToUse = enforcedDateFormatLang
  }
  if (uct) {
    //return format(date)
    const localTime = new Date(date)
    const diffHours = localTime.getTimezoneOffset() / -60
    localTime.setHours(localTime.getHours() + diffHours)
    if (returnUnFormmatedLocalTime) {
      return localTime.toISOString()
    }
    var d = i18n.d(localTime, type, localeToUse)
    return d
  }
  const newDate = Date.parse(date)
  return i18n.d(newDate, type, localeToUse)
}
